import * as types from './types';
import { loading } from 'State/actions';
import { createToast, toastType } from 'Common/ToastHelper';

export const getSelectionLetters = values => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SELECTION_LETTERS_FETCHING, true));

    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Verification/SelectionLetters`,
        values
      );
      if (response.data.Data && response.data.Data.Report) {
        dispatch({
          type: types.SELECTION_LETTERS_GET_REPORT,
          payload: response.data.Data.Report,
        });
        dispatch({
          type: types.SELECTION_LETTERS_SELECTED_HOUSEHOLDS,
          payload: response.data.Data.SelectedHouseholds,
        });
      } else {
        dispatch({
          type: types.SELECTION_LETTERS_GET_REPORT,
          payload: 'No Data',
        });
      }
    } catch (error) {
      dispatch({
        type: types.SELECTION_LETTERS_FETCH_ERROR,
        payload: error.response,
      });
      createToast(toastType.error, 'Error', 'Failed to generate report.');
    }

    dispatch(loading(types.SELECTION_LETTERS_FETCHING, false));
  };
};

export const writeSuccess = SelectedHouseholds => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.SELECTION_LETTERS_WRITING_TO_DB, true));
      await MPWWebApi.postGenericInsertUpdate(
        `Verification/SelectionLetters/Success`,
        SelectedHouseholds
      );
      dispatch(getInitialData());
    } catch (error) {
      dispatch({
        type: types.SELECTION_LETTERS_FETCH_ERROR,
        payload: error.response,
      });
      createToast(toastType.error, 'Error', 'Failed to generate report.');
    } finally {
      dispatch(loading(types.SELECTION_LETTERS_WRITING_TO_DB, false));
    }
  };
};

export const clearReport = () => {
  return {
    type: types.SELECTION_LETTERS_GET_REPORT,
    payload: null,
  };
};

export const getInitialData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SELECTION_LETTERS_FETCHING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        'Verification/SelectionLetters'
      );
      dispatch({
        type: types.SELECTION_LETTERS_GET_DATA,
        payload: response.data.Data,
      });
    } catch (error) {
      dispatch({
        type: types.SELECTION_LETTERS_FETCH_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.SELECTION_LETTERS_FETCHING, false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/selectionletters/state/selectionletters/actions.js